import { Link } from 'react-router-dom';
import { Dog, Mail, MapPin, Phone } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-[#4A90E2] flex items-center justify-center">
                <Dog className="w-5 h-5 text-white" strokeWidth={2} />
              </div>
              <span className="font-['Nunito'] font-extrabold text-lg text-[#1A1D20]">DoggoHub</span>
            </div>
            <p className="text-sm text-[#5C636A] leading-relaxed">
              Your trusted marketplace to find the perfect furry companion. Connecting dog lovers since 2024.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Nunito'] font-bold text-[#1A1D20] mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: 'Dogs for Sale', path: '/dogs-for-sale' },
                { label: 'Dog Breeds', path: '/dog-breeds' },
                { label: 'Dog Matcher', path: '/dog-matcher' },
                { label: 'Blog', path: '/blog' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-[#5C636A] hover:text-[#4A90E2] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-['Nunito'] font-bold text-[#1A1D20] mb-4">Resources</h4>
            <ul className="space-y-2">
              {[
                { label: 'About Us', path: '/about' },
                { label: 'Contact', path: '/contact' },
                { label: 'FAQ', path: '/faq' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-[#5C636A] hover:text-[#4A90E2] transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Nunito'] font-bold text-[#1A1D20] mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-[#5C636A]">
                <Mail className="w-4 h-4 text-[#4A90E2]" /> hello@doggohub.com
              </li>
              <li className="flex items-center gap-2 text-sm text-[#5C636A]">
                <Phone className="w-4 h-4 text-[#4A90E2]" /> (555) 123-4567
              </li>
              <li className="flex items-center gap-2 text-sm text-[#5C636A]">
                <MapPin className="w-4 h-4 text-[#4A90E2]" /> San Francisco, CA
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-10 pt-6 text-center">
          <p className="text-xs text-[#5C636A]">
            &copy; {new Date().getFullYear()} DoggoHub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
